import Select from '@/components/elements/select'
import { GeneralDetailsPlansPersonalized } from '@/entities/api/products/details'
import ProductEntity from '@/entities/api/products/products'
import { booleanMap } from '@/utils/maps/boolean-map'
import { daysMap } from '@/utils/maps/days-map'
import { modalitiesMap } from '@/utils/maps/modalities-map'
import { placeMap } from '@/utils/maps/place-map'
import { Box, Heading } from '@chakra-ui/react'
import { Control } from 'react-hook-form'

const PlansForm = ({
	control,
	product,
}: {
	control: Control<any>
	product?: ProductEntity
}) => {
	return (
		<>
			<Box
				w='full'
				display='flex'
				justifyContent='start'
				alignItems='center'
				mt='4'
			>
				<Heading
					as='h5'
					fontSize={{ base: 'md', md: 'lg' }}
					color='black'
					fontWeight='900'
				>
					Detalles generales
				</Heading>
			</Box>
			<Select
				name='details.general_details.training_plan'
				label='¿Incluye guia de entrenamiento?'
				placeholder='Escoge si el plan tiene guia de entrenamiento'
				options={booleanMap}
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.general_details as GeneralDetailsPlansPersonalized
							)?.training_plan ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.general_details.nutrition_plan'
				label='¿Incluye guia de alimentacion?'
				placeholder='Escoge si el plan tiene guia de alimentacion'
				defaultValue={
					product &&
					(booleanMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.general_details as GeneralDetailsPlansPersonalized
							)?.nutrition_plan ?? '')
					) ?? { label: '', value: '' })
				}
				options={booleanMap}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.general_details.duration'
				label='Duracion del plan en dias (30, 15..)'
				placeholder='Escoge la duracion en dias del plan'
				options={daysMap}
				defaultValue={
					product &&
					(daysMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.general_details as GeneralDetailsPlansPersonalized
							)?.duration ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				name='details.general_details.modality'
				label='Modalidad del plan'
				placeholder='Escoge la modalidad del plan'
				options={modalitiesMap}
				defaultValue={
					product &&
					(modalitiesMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.general_details as GeneralDetailsPlansPersonalized
							)?.modality ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
			<Select
				label='Lugar del plan'
				placeholder='Escoge el lugar donde se llevara acabo el entrenamiento'
				name='details.general_details.place'
				options={placeMap}
				defaultValue={
					product &&
					(placeMap.find(
						(obj) =>
							obj.value ===
							((
								product?.details
									?.general_details as GeneralDetailsPlansPersonalized
							)?.place ?? '')
					) ?? { label: '', value: '' })
				}
				control={control}
				isRequired={true}
			/>
		</>
	)
}

export default PlansForm
